import { useFsFlag } from "@flagship.io/react-sdk";

function withFlagship(Component, abTestsName) {
	//TODO pour les abtests au prebook, reutiliser le flags prebook_flags
	function ComponentWithFlagship(props) {
		const abTests = useFsFlag(abTestsName);
		const abTestsValues = abTests.getValue(undefined);

		return <Component abTestsValues={abTestsValues} {...props} />;
	}

	return ComponentWithFlagship;
}

export default withFlagship;
